import type { ReactNode } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { AuthProvider } from "./provider";

// Standard AuthProvider wiring as a route-layout element. Folds the per-app
// `<AuthProvider config={{ authUrl, productName, clientVariant, navigate }}>` boilerplate
// (and fixes board/dsp's redundant double-AuthProvider) into one component.
//
//   // in routes.tsx, as a layout element wrapping the app:
//   { element: <AppAuthProvider authUrl={getEnv("BOARD_API_URL")} product="board" clientVariant="web" />, children: [...] }
//
// `authUrl` is passed in (the app computes it via getEnv) so this package needn't depend
// on @trillion/ui's env helper.
export function AppAuthProvider({
  authUrl,
  product,
  clientVariant,
  children,
}: {
  authUrl: string;
  product: string;
  clientVariant: "web" | "admin";
  children?: ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <AuthProvider
      config={{
        authUrl,
        productName: product,
        clientVariant,
        navigate: (path) => navigate(path, { replace: true }),
      }}
    >
      {children ?? <Outlet />}
    </AuthProvider>
  );
}
